import React from "react"
import { Chip, FontIcon, IconButton } from "material-ui"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import AddIPAddressDialog from "./AddIPAddressDialog"
import AppStateStore from "../../../stores/AppStateStore"
import { grey700 } from "material-ui/styles/colors"
interface IProps {
  ipAddresses: string[]
  readonly: boolean
  handleChange(ipAddresses: string[]): void
}
interface IState {
  ipAddresses: string[]
  openAddIPAddressDialog: boolean
  editIPAddress: string
}

export default class IPAddressChip extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      ipAddresses: props.ipAddresses,
      openAddIPAddressDialog: false,
      editIPAddress: null
    }
    autobind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ipAddresses: nextProps.ipAddresses })
  }

  handleDelete(ipAddress) {
    let ipAddresses = this.state.ipAddresses.slice()
    ipAddresses = ipAddresses.filter(item => item !== ipAddress)
    this.setState({ ipAddresses }, () =>
      this.props.handleChange && this.props.handleChange(ipAddresses)
    )
  }

  handleAdd(breakItem) {
    const ipAddresses = this.state.ipAddresses.slice()
    ipAddresses.push(breakItem)
    this.setState({ ipAddresses, openAddIPAddressDialog: false, editIPAddress: null }, () => {
      this.props.handleChange && this.props.handleChange(ipAddresses)
    })
  }

  handleUpdate(breakItem) {
    const ipAddresses = this.state.ipAddresses.slice()
    const indexOf = this.state.ipAddresses.indexOf(this.state.editIPAddress)
    ipAddresses[indexOf] = breakItem
    this.setState({ ipAddresses, openAddIPAddressDialog: false, editIPAddress: null }, () => {
      this.props.handleChange && this.props.handleChange(ipAddresses)
    })
  }

  render() {
    return (
      <div style={{ position: "relative" }}>
        {this.props.readonly && !this.state.ipAddresses.length ?
          <span style={{ color: grey700, fontSize: 14, marginLeft: 5 }}>{strings.All_IP_Address_approved}</span> :
          <span style={{ color: "rgba(0, 0, 0, 0.3)", fontSize: 13, marginLeft: 5 }}>{strings.IP_Address}</span>
        }
        <div style={{ display: "flex", flexWrap: "wrap", marginTop: -7, paddingBottom: 5 }}>
          {this.state.ipAddresses.map((item, index) =>
            <Chip
              data-intercom-target={"UpdateIP"}
              style={{ marginTop: 10, marginRight: 5, height: 35 }}
              key={index}
              onRequestDelete={this.props.readonly ?
                null :
                () =>
                  AppStateStore.setConfirmDialogContent({
                    content: strings.Are_you_sure_you_want_to_delete_this_IP,
                    confirm: () => this.handleDelete(item)
                  })
              }
              onClick={() => !this.props.readonly && !AppStateStore.confirmDialogContent &&
                this.setState({ openAddIPAddressDialog: true, editIPAddress: item })
              }
              labelStyle={{ width: 120, textAlign: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
            >
              <span>{item}</span>
            </Chip>
          )}
          {!this.props.readonly &&
            <IconButton
              data-intercom-target={"IP-Btn-OpenIPAddDialog"}
              style={{ height: 33, marginTop: 2, display: "inline-block" }}
              onTouchTap={() => this.setState({ openAddIPAddressDialog: true, editIPAddress: null })}
            >
              <FontIcon className="fa fa-plus-circle" />
            </IconButton>
          }
        </div>
        {this.state.openAddIPAddressDialog &&
          <AddIPAddressDialog
            editIPAddress={this.state.editIPAddress}
            hierarchyIPAddresses={this.state.ipAddresses}
            handleClose={() => this.setState({ openAddIPAddressDialog: false, editIPAddress: null })}
            handleAdd={this.handleAdd}
            handleUpdate={this.handleUpdate}
          />
        }
      </div>
    )
  }
}